var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubwalletIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 250 250",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h250v250H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m85.476 137.062 17.283 9.336-19.244 8.463L66 145.749l19.476-8.687Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m103.315 90.4013-.015 8.193-19.8161 8.8557-.023-27.3797 19.8541 10.331Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m101.315 159.579 44.062-19.42-61.8926-32.7 19.8146-8.8574 80.173 42.2294-81.979 35.943-.178-17.195Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M183.471 140.828v26.67l-99.9183 43.596-.039-56.228 19.2443-8.463-.039 12.563-.046 17.296 80.798-35.434Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m66 145.75 17.515 9.112.031 56.228L66 202.334V145.75Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m183.448 112.451.031-24.6619-20.51 8.949-.008 24.7779 20.487-9.065Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M66 47.227 86.58 38l96.9 49.788-20.533 8.95L66 47.228v-.001Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M162.97 121.515V96.7366L66 47.2266v71.1774l58.196 31.11 21.259-9.382-61.947-32.677-.047-27.4504 79.509 41.5104Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 62.042,
    x2: 137.056,
    y1: 145.961,
    y2: 145.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00E5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00A5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#0040D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#0025D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 93.3879,
    x2: 93.3879,
    y1: 117.21,
    y2: 55.8283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#00E5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#00A5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#0040D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#0025D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 83.4804,
    x2: 243.678,
    y1: 137.69,
    y2: 137.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEC9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#E4D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#A4A6B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3F57C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#0025D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 50.8917,
    x2: 255.464,
    y1: 175.96,
    y2: 175.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#62A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#1032D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 59.634,
    x2: 102.979,
    y1: 177.57,
    y2: 179.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#9ACEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#47C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#14C5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 143.134,
    x2: 280.433,
    y1: 105.198,
    y2: 102.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#00E5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#00A5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#0040D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#0025D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 66,
    x2: 284.982,
    y1: 67.368,
    y2: 67.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E6D5BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#A7D6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#43D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#37B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2B8CA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#216B7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#184E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#10353F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#0A2228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#061316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#020809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#010202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 41.744,
    x2: 213.009,
    y1: 98.3706,
    y2: 98.3706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#9ACEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#47C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#14C5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4BF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubwalletIcon);
export default __webpack_public_path__ + "static/media/subwallet-icon.4e4dc44282b864749c7d7579a92635b2.svg";
export { ForwardRef as ReactComponent };